import { CircularProgress, Box } from "@mui/material";
import { ModulesDashboard } from "../../@components/ModulesDashboard/ModulesDashboard";
import { useAccountInfo } from "../../hooks/useAccountInfo";
import { modules as baseModules } from "../../utils/modules";
import { FullWidthSection } from "../../@components/ReusableComponents/FullWidthSection";
import { LayoutWrapper } from "../../@components/ReusableComponents/LayoutWrapper";
import theme from "../../theme";

export function Home() {
  // Account Info from hooks
  const { accountInfo, loading } = useAccountInfo();

  // Show loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Build the dashboard modules list from the top-level modules array
  const availableModules = (baseModules || []).filter((mod) => {
    // If module doesn't require a permission, always include
    if (!mod.requiresPermission) return true;

    // If the account explicitly has the permission, include
    if (accountInfo && accountInfo[mod.requiresPermission]) return true;

    // For parent modules that expose submodules, include if any submodules are available
    if (mod.hasSubModules && typeof mod.getSubModules === "function") {
      try {
        const subs = mod.getSubModules(accountInfo);
        return Array.isArray(subs) && subs.length > 0;
      } catch (e) {
        return false;
      }
    }

    return false;
  });
  return (
    <FullWidthSection
      sx={{
        background: theme.palette.linearGradient.gradientMain,
      }}
    >
      <LayoutWrapper>
        <ModulesDashboard
          modules={availableModules}
          accountInfo={accountInfo}
        />
      </LayoutWrapper>
    </FullWidthSection>
  );
}
